import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type EntityOverviewTab = 'map' | 'table';

interface EntityOverviewStore {
  tab: EntityOverviewTab;
  setTab: (tab: EntityOverviewTab) => void;
}

// Seed the tab from the URL so a hard refresh of e.g. /stations?view=map starts
// on the correct tab from the first render, without a flash of the default tab.
const getInitialTab = (): EntityOverviewTab => {
  if (typeof window === 'undefined') {
    return 'table';
  }
  const view = new URLSearchParams(window.location.search).get('view');
  return view === 'map' ? 'map' : 'table';
};

const entityOverviewStore = create<EntityOverviewStore>()(
  devtools(
    (set) => ({
      tab: getInitialTab(),
      setTab: (tab) => set({ tab }),
    }),
    { name: 'entityOverview-store', enabled: process.env.NODE_ENV !== 'test' },
  ),
);

export default entityOverviewStore;
